import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { APP_ROLE_OPTIONS, AppRoleOption, maskIncludesRole } from '../app-roles';

type RoleAccessCellParams = ICellRendererParams<any, any, any>;

export const MENU_ACCESS_ROLE_OPTIONS: AppRoleOption[] = APP_ROLE_OPTIONS;

export function parseAccessMask(value: any): number {
  const parsedMask = Number(value);
  return Number.isFinite(parsedMask) ? parsedMask : 0;
}

export function roleIsEnabled(accessMask: any, roleValue: number): boolean {
  return maskIncludesRole(parseAccessMask(accessMask), roleValue);
}

export function setRoleAccess(accessMask: any, roleValue: number, checked: boolean): number {
  const parsedMask = parseAccessMask(accessMask);
  const currentlyEnabled = maskIncludesRole(parsedMask, roleValue);

  if (checked && !currentlyEnabled) {
    return parsedMask + roleValue;
  }

  if (!checked && currentlyEnabled) {
    return parsedMask - roleValue;
  }

  return parsedMask;
}

export function buildRoleAccessColumns(
  rowLabelField: string,
  onToggle: (checked: boolean, params: RoleAccessCellParams, role: AppRoleOption) => void
): ColDef[] {
  return MENU_ACCESS_ROLE_OPTIONS.map((role) => ({
    headerName: role.label,
    width: Math.max(112, role.label.length * 9 + 52),
    minWidth: 112,
    sortable: false,
    filter: false,
    editable: false,
    cellClass: 'role-access-cell',
    cellRenderer: (params: RoleAccessCellParams) => {
      const checkbox = document.createElement('input');
      const rowLabel = params.data?.[rowLabelField] ? String(params.data[rowLabelField]) : 'menu item';

      checkbox.type = 'checkbox';
      checkbox.className = 'role-access-checkbox';
      checkbox.checked = roleIsEnabled(params.data?.access_roles, role.value);
      checkbox.setAttribute('aria-label', `${role.label} access for ${rowLabel}`);
      checkbox.addEventListener('change', () => {
        onToggle(checkbox.checked, params, role);
      });

      return checkbox;
    },
  }));
}
